<template>
    <div class="page-aside" id="page-aside">
        <div class="page-aside-content px-lg-30 py-50" id="page-aside-content">

        </div>
        <div class="page-aside-close icon" id="page-aside-close">
            <!-- <svg-icon name="close" /> -->
            <img :src="require('@/assets/sprite/svg/close.svg?raw')" alt="">
        </div>
    </div>

</template>

<style lang="scss">
@import '@/assets/css/vars.scss';
.page-aside {
    position: fixed;
    right: 0;
    top: 0;
    height: 100vh;
    width: 45%;
    max-width: 870px;
    overflow: auto;
    overflow-x: hidden;
    @include color('white', 'background-color');
    z-index: 1050;
    transform: translateX(101%);
    opacity: 0;
    transition: .35s transform $trFun;

    @include media(max, lg) {
        width: 100%;
    }

    .page-aside-close {
        position: absolute;
        right: 20px;
        top: 20px;
        width: 25px;
        height: 25px;
        cursor: pointer;
        transition: .3s opacity $trFun;

        @include media(max, lg) {
            right: 15px;
        }

        @media (hover: hover) {
            &:hover {
                opacity: 0.6;
            }

            &:active {
                opacity: 1;
            }
        }
    }

    .page-aside-floating {
        position: sticky;
        left: 0;
        bottom: 0;
    }

    &.show {
        transform: translateX(0);
        opacity: 1;
    }
}
.page-aside-overlay {
    display: none;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1030;
    width: 100%;
    height: 100%;
    @include color('black', 'background-color');
    opacity: 0.4;
}
</style>

<script>
export default {
    name: 'PageAside',
    mounted() {

    }
}
</script>
